module.exports = __webpack_public_path__ + "media/illustrations/drag-n-drop-52475090.svg";